import React, { useState } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import './styles/TextEditor.css';

function TextEditor({ data, onUpdate }) {
  const [showCodeModal, setShowCodeModal] = useState(false);
  const [currentCode, setCurrentCode] = useState('');
  const [codeType, setCodeType] = useState(''); // 'title' or 'content'
  
  // 查看源代码
  const handleViewCode = (type) => {
    const code = type === 'title' ? (data.title || '') : (data.content || '');
    setCurrentCode(code);
    setCodeType(type);
    setShowCodeModal(true);
  };
  
  // 复制代码
  const handleCopyCode = () => {
    navigator.clipboard.writeText(currentCode).then(() => {
      alert('代码已复制到剪贴板！');
    }).catch(err => {
      console.error('复制失败:', err);
      alert('复制失败，请手动复制');
    });
  };
  const modules = {
    toolbar: [
      [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
      [{ 'font': [] }],
      [{ 'size': ['small', false, 'large', 'huge'] }],
      ['bold', 'italic', 'underline', 'strike'],
      [{ 'color': [] }, { 'background': [] }],
      [{ 'align': [] }],
      [{ 'list': 'ordered'}, { 'list': 'bullet' }],
      [{ 'indent': '-1'}, { 'indent': '+1' }],
      ['link', 'image'],
      ['clean']
    ]
  };

  const formats = [
    'header', 'font', 'size',
    'bold', 'italic', 'underline', 'strike',
    'color', 'background',
    'list', 'bullet', 'indent',
    'align',
    'link', 'image'
  ];

  return (
    <div className="text-editor-container">
      {/* 整体背景色设置 */}
      <div className="background-color-section">
        <div className="bg-color-header">
          <span className="bg-color-title">内容区背景色</span>
        </div>
        <div className="bg-color-selector">
          <input
            type="color"
            value={data.backgroundColor || '#ffffff'}
            onChange={(e) => onUpdate({ ...data, backgroundColor: e.target.value })}
            className="color-input-large"
          />
          <span className="color-value">{data.backgroundColor || '#ffffff'}</span>
        </div>
      </div>

      <div className="editor-section">
        <div className="editor-header">
          <span className="editor-title">请直播口</span>
          <div className="editor-option">
            <button 
              className="view-code-btn-inline"
              onClick={() => handleViewCode('title')}
              title="查看源代码"
            >
              &lt;/&gt;
            </button>
            <label className="option-label">选择文字颜色</label>
            <input
              type="color"
              value={data.titleColor || '#000000'}
              onChange={(e) => onUpdate({ ...data, titleColor: e.target.value })}
              className="color-picker-small"
            />
          </div>
        </div>
        
        <div className="quill-container">
          <ReactQuill
            theme="snow"
            value={data.title || ''}
            onChange={(value) => onUpdate({ ...data, title: value })}
            modules={modules}
            formats={formats}
            placeholder="标题"
          />
        </div>
        <div className="char-count">0 字</div>

        {/* 标题样式细节 */}
        <div style={{ display: 'flex', gap: 12, alignItems: 'center', flexWrap: 'wrap', marginTop: 8 }}>
          <label>字号</label>
          <input type="text" placeholder="如 20px" value={(data.titleStyle && data.titleStyle.fontSize) || ''} onChange={(e) => onUpdate({ ...data, titleStyle: { ...(data.titleStyle || {}), fontSize: e.target.value } })} />
          <label>行高</label>
          <input type="text" placeholder="如 1.6" value={(data.titleStyle && data.titleStyle.lineHeight) || ''} onChange={(e) => onUpdate({ ...data, titleStyle: { ...(data.titleStyle || {}), lineHeight: e.target.value } })} />
          <label>字距</label>
          <input type="text" placeholder="如 0px" value={(data.titleStyle && data.titleStyle.letterSpacing) || ''} onChange={(e) => onUpdate({ ...data, titleStyle: { ...(data.titleStyle || {}), letterSpacing: e.target.value } })} />
          <label>对齐</label>
          <select value={(data.titleStyle && data.titleStyle.align) || ''} onChange={(e) => onUpdate({ ...data, titleStyle: { ...(data.titleStyle || {}), align: e.target.value } })}>
            <option value="">默认</option>
            <option value="left">左</option>
            <option value="center">中</option>
            <option value="right">右</option>
          </select>
          <label>标题下间距</label>
          <input type="number" min="0" value={(data.spacing && data.spacing.titleGap) || 0} onChange={(e) => onUpdate({ ...data, spacing: { ...(data.spacing || {}), titleGap: Number(e.target.value) } })} />
        </div>
      </div>

      <div className="editor-section">
        <div className="editor-header">
          <span className="editor-title">内容</span>
          <div className="editor-option">
            <button 
              className="view-code-btn-inline"
              onClick={() => handleViewCode('content')}
              title="查看源代码"
            >
              &lt;/&gt;
            </button>
            <input
              type="checkbox"
              id="content-color-toggle"
              checked={!!data.contentColor}
              onChange={(e) => onUpdate({ 
                ...data, 
                contentColor: e.target.checked ? '#000000' : '' 
              })}
            />
            <label htmlFor="content-color-toggle" className="option-label">选择颜色</label>
            {data.contentColor && (
              <input
                type="color"
                value={data.contentColor}
                onChange={(e) => onUpdate({ ...data, contentColor: e.target.value })}
                className="color-picker-small"
              />
            )}
          </div>
        </div>
        
        <div className="quill-container">
          <ReactQuill
            theme="snow"
            value={data.content || ''}
            onChange={(value) => onUpdate({ ...data, content: value })}
            modules={modules}
            formats={formats}
            placeholder="内容"
          />
        </div>
        <div className="char-count">0 字</div>

        {/* 正文样式细节 */}
        <div style={{ display: 'flex', gap: 12, alignItems: 'center', flexWrap: 'wrap', marginTop: 8 }}>
          <label>字号</label>
          <input type="text" placeholder="如 14px" value={(data.contentStyle && data.contentStyle.fontSize) || ''} onChange={(e) => onUpdate({ ...data, contentStyle: { ...(data.contentStyle || {}), fontSize: e.target.value } })} />
          <label>行高</label>
          <input type="text" placeholder="如 1.8" value={(data.contentStyle && data.contentStyle.lineHeight) || ''} onChange={(e) => onUpdate({ ...data, contentStyle: { ...(data.contentStyle || {}), lineHeight: e.target.value } })} />
          <label>字距</label>
          <input type="text" placeholder="如 0px" value={(data.contentStyle && data.contentStyle.letterSpacing) || ''} onChange={(e) => onUpdate({ ...data, contentStyle: { ...(data.contentStyle || {}), letterSpacing: e.target.value } })} />
          <label>对齐</label>
          <select value={(data.contentStyle && data.contentStyle.align) || ''} onChange={(e) => onUpdate({ ...data, contentStyle: { ...(data.contentStyle || {}), align: e.target.value } })}>
            <option value="">默认</option>
            <option value="left">左</option>
            <option value="center">中</option>
            <option value="right">右</option>
          </select>
          <label>段落间距</label>
          <input type="text" placeholder="如 8px" value={(data.contentStyle && data.contentStyle.paragraphGap) || ''} onChange={(e) => onUpdate({ ...data, contentStyle: { ...(data.contentStyle || {}), paragraphGap: e.target.value } })} />
          <label>首行缩进</label>
          <input type="text" placeholder="如 2em" value={(data.contentStyle && data.contentStyle.indent) || ''} onChange={(e) => onUpdate({ ...data, contentStyle: { ...(data.contentStyle || {}), indent: e.target.value } })} />
        </div>
      </div>
      
      {/* 源代码查看模态框 */}
      {showCodeModal && (
        <div className="code-modal-overlay" onClick={() => setShowCodeModal(false)}>
          <div className="code-modal" onClick={(e) => e.stopPropagation()}>
            <div className="code-modal-header">
              <h3>源代码 - {codeType === 'title' ? '标题' : '内容'}</h3>
              <button className="code-modal-close" onClick={() => setShowCodeModal(false)}>
                ×
              </button>
            </div>
            <div className="code-modal-body">
              <textarea 
                className="code-textarea" 
                value={currentCode} 
                readOnly
              />
            </div>
            <div className="code-modal-footer">
              <button className="btn-secondary" onClick={() => setShowCodeModal(false)}>
                取消
              </button>
              <button className="btn-primary" onClick={handleCopyCode}>
                复制
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default TextEditor;
